module.exports = __webpack_public_path__ + "static/media/7.b389c943.JPG";